const cellSignalDataPointID = 'ms_cell_signal';
const gpsSignalSeriesID = 'gps';

export default class DeviceDiagnosticService {
  constructor(appSettings, $http, $q, gettext) {
    'ngInject';

    this.seriesEndpoint = `${appSettings.BaseIcebergUrl}/1537/series`;
    this.$http = $http;
    this.gettext = gettext;
  }

  get SignalStatus() {
    return {
      None: this.gettext('None'),
      Poor: this.gettext('Poor'),
      Fair: this.gettext('Fair'),
      Good: this.gettext('Good'),
      Excellent: this.gettext('Excellent'),
      Unavailable: this.gettext('Unavailable'),
      Loading: this.gettext('Loading'),
      Error: this.gettext('Error'),
      Ideal: this.gettext('Ideal'),
    };
  }

  get GpsQuality() {
    // based on ticket comment https://onei3z.atlassian.net/browse/ESDA-1972?focusedCommentId=21019
    // got modified to text values in https://onei3z.atlassian.net/browse/ESDA-2421
    return {
      poor: this.SignalStatus.Poor,
      fair: this.SignalStatus.Fair,
      good: this.SignalStatus.Good,
      excellent: this.SignalStatus.Excellent,
      ideal: this.SignalStatus.Ideal,
    };
  }

  getSeriesByDevice(esn, tag) {
    const tagQuery = tag ? `&tag=${tag}` : '';
    const url = `${this.seriesEndpoint}?attr[device]=${esn}${tagQuery}`;
    return this.$http.get(url).then((res) => {
      return res.data;
    });
  }

  getLastReportedGpsSeries(equipmentId) {
    const url = `${this.seriesEndpoint}?attr[equipment]=${equipmentId}&tag=${gpsSignalSeriesID}`;
    return this.$http.get(url).then((res) => {
      const [gps] = res.data || [];
      return this.getGpsStatusInfo(gps);
    });
  }

  getLastReportedCellSignalSeries(esn) {
    return this.getSeriesByDevice(esn, cellSignalDataPointID).then(([cellSignal]) =>
      this.getCellSignalStatusInfo(cellSignal),
    );
  }

  /**
   *  @param {*} gpsSeries
   * return  {last, status}
   */
  getGpsStatusInfo(gpsSeries) {
    const { last } = gpsSeries || {};
    const { attrs } = last || {};
    const { fix_quality: fixQuality = null } = attrs || {};

    if (fixQuality === null) {
      return { last, status: this.SignalStatus.Unavailable };
    }
    const status = this.GpsQuality[fixQuality.toLowerCase()] || fixQuality;

    return { last, status };
  }

  /**
   * return object {last,status}
   * @param {*} cellSignalSeries
   */
  getCellSignalStatusInfo(cellSignalSeries) {
    const { last } = cellSignalSeries || {};

    if (!last) {
      return { status: this.SignalStatus.Unavailable };
    }

    const { v } = last || {};

    switch (true) {
      case v > 80:
        return { last, status: this.SignalStatus.Excellent };
      case v > 60:
        return { last, status: this.SignalStatus.Good };
      case v > 40:
        return { last, status: this.SignalStatus.Fair };
      case v > 20:
        return { last, status: this.SignalStatus.Poor };
      default:
        return { last, status: this.SignalStatus.None };
    }
  }

  filterGpsSeries(series = []) {
    return series.find((s) => s.dataId === gpsSignalSeriesID);
  }
}
